import { BenefitIcon, BenefitIconGlyph } from "./benefit-icon";
export var ImpactResultIcon = BenefitIcon;
export var ImpactResultIconGlyph = BenefitIconGlyph;